<div ngbDropdown>
  <button ngbDropdownToggle
          class="btn btn-outline-primary border-0"
          id="deviceDetailContextMenu">
    <fa-icon [icon]="['fas', 'ellipsis-h']"></fa-icon>
  </button>

  <div ngbDropdownMenu
       aria-labelledby="deviceDetailContextMenu">
    <button ngbDropdownItem
            type="button"
            (click)="rebootRequest()">Reboot</button>
    @if (!device()?.isLostModeEnabled) {
      <button ngbDropdownItem
              (click)="openLostModeConfirmationModal()">Lost</button>
    } @else {
      <button ngbDropdownItem
              (click)="disableLostModeRequest()">Disable Lost Mode</button>
    }
  </div>
</div>